import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import OtpInput from "react-otp-input";
import Notiflix, { Report } from "notiflix";
import moment from "moment";
import { useHistory } from "react-router-dom";
import verifyImg from "../../assets/profile/verify.jpg";
import PostApiCall from "../../Api/Api";
import { delay } from "../../Helper/ToastDelay";
import Login from "./Login";
import { fetchData } from "../../Store/Actions/LoginAction";
import { useDispatch } from "react-redux";

const VerifyEmail = () => {
  const [OtpEntered, setOtpEntered] = useState("");
  const [showError, setShowError] = useState(false);
  const [timer, setTimer] = useState(60);
  const [showResendButton, setShowResendButton] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    let interval = null;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      clearInterval(interval);
      setShowResendButton(true);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const onVerifyClicked = async () => {
    if (OtpEntered.length < 6) {
      setShowError(true);
    } else {
      setShowError(false);
      try {
        const resultdes = await PostApiCall.postRequest(
          {
            name: history.location.state.name,
            otp: OtpEntered,
          },
          "VerifyCandidateEmail"
        );

        const obj = await resultdes.json();

        if (resultdes.status === 200 || resultdes.status === 201) {
          // toast.success(obj.data[0].Message, {
          //   autoClose: delay,
          //   toastId: 1,
          // });
          const payload = {
            email: history.location.state.name,
            password: history.location.state.password,
          };
          const method = "POST";
          const url = "CheckIfJobUserExists"; // Replace with your actual API endpoint
          // Dispatch the fetchData action
          const userExist = await dispatch(fetchData(payload, method, url));

          if (userExist) {
            history.push("/account");
            // Notiflix.Loading.init({ svgColor: "#c16d18" });
            // Report.success("Success", "Logged in successfully", "Continue");
          }
        } else {
          toast.error(obj.data, {
            autoClose: delay,
            toastId: 1,
          });
        }
      } catch (err) {
        toast.error(err.toString(), {
          autoClose: delay,
          toastId: 1,
        });
      }
    }
  };

  const resentOTPHandler = () => {
    setOtpEntered("");
    Notiflix.Loading.standard();
    PostApiCall.postRequest(
      {
        name: history.location.state.name,
        updatedat: moment().format("MMM DD, YYYY h:mm A"),
      },
      "GenerateOTP"
    )
      .then((result) => {
        if (!result.ok) {
          throw new Error("Failed to fetch data");
        }
        Notiflix.Loading.remove();
        toast.success("OTP has been sent to your email", {
          autoClose: delay,
        });
        setTimer(60); // Reset timer to 60 seconds
        setShowResendButton(false);
      })
      .catch((error) => {
        Notiflix.Loading.remove();
        console.error("Error verifying email:", error);
      });
  };

  return (
    <div
      className="App bg-light d-flex justify-content-center align-items-center"
      style={{ height: "100vh" }}
    >
      <ToastContainer />
      <section id="content" className="section-padding mt-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5 col-md-6 col-xs-12">
              <div className="page-login-form box bg-white">
                <h3 className="text-center">
                  <img className="w-25" src={verifyImg} alt="verify mail" />
                  <p
                    style={{
                      fontSize: "14px",
                      color: "black",
                      textTransform: "initial",
                    }}
                  >
                    Please check your email
                  </p>
                  <p
                    className="text-center"
                    style={{ fontSize: "13px", textTransform: "initial" }}
                  >
                    {history.location.state.name && (
                      <span>
                        We have sent a code to{" "}
                        <b>{history.location.state.name}</b>
                      </span>
                    )}
                  </p>
                </h3>
                <form
                  className="login-form"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="form-group otp-login">
                    <OtpInput
                      value={OtpEntered}
                      onChange={(e) => setOtpEntered(e)}
                      numInputs={6}
                      isInputNum={true}
                      separator={<span>&nbsp;&nbsp;&nbsp;</span>}
                    />
                  </div>
                  {showError && (
                    <div className="text-center text-danger">Invalid Input</div>
                  )}
                  <div className="text-center">
                    <button
                      className="btn btn-common log-btn mt-3 w-75"
                      onClick={onVerifyClicked}
                    >
                      Submit
                    </button>
                  </div>
                </form>
                <ul className="form-links">
                  <li className="text-center">
                    {showResendButton ? (
                      <div
                        style={{ cursor: "pointer" }}
                        className="baseTextColor"
                        onClick={resentOTPHandler}
                      >
                        Resend OTP
                      </div>
                    ) : (
                      <div>
                        Resend OTP in{" "}
                        <span
                          className="baseTextColor"
                          style={{ fontWeight: "bold" }}
                        >
                          {timer}s
                        </span>
                      </div>
                    )}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VerifyEmail;
